@if (sendInvite()) {
    @if (allSent()) {
        <div class="bg-card text-center p-4 my-4">
            <div class="background p-2">
                <p>{{ "cycle.no_data_row" | translate }}</p>
            </div>
        </div>
    } @else {
        <adaa-data-table
            #adaaDataTable
            titleHeader="cycle.title"
            [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.STRATEGIC_CYCLE_ENTITIES"
            [enableAdd]="false"
            [enableActionsCell]="false"
            [tableInputs]="tableInputs"
            [isLocalData]="true"
            [resetPaginationOnDataUpdate]="false"
            [localData]="planEntities()"
            (inputListChanged)="formatEntities($event)"
        />
    }
    <div class="col-12 mb-3">
        <adaa-form-action-buttons
            [saveButtonTitle]="'common.form.button.send' | translate"
            [showSaveButton]="!allSent()"
            (saveClicked)="sendToEntities()"
            (cancelClicked)="close()"
        ></adaa-form-action-buttons>
    </div>
} @else {
    <adaa-data-table
        #adaaDataTable
        titleHeader="cycle.title"
        apiPrefix="plan"
        [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.CYCLES"
        [hideDeleteRules]="hideDeleteRules"
        [hideEditRules]="hideEditRules"
        [customActionButtons]="customButtons"
        [itemTypeId]="Constants.CONSTANT_PERMISSIONS.CYCLES"
        (addNewClicked)="addNewClicked()"
        (actionClicked)="getAction($event)"
    />
}
